
import { defineComponent } from 'vue'

import pluralize from 'pluralize'
import OwnerBillingMixin from '~/mixins/ownerBillingMixin'
import { GetUpgradeCodeQualitySubscriptionPlanInfoPayload } from '~/types/types'
import { formatDate, parseISODate } from '~/utils/date'
import { formatUSD } from '~/utils/string'
import { getDefaultAvatar } from '~/utils/ui'

export default defineComponent({
  name: 'UpdateSubscriptionModal',
  mixins: [OwnerBillingMixin],
  props: {
    newPlanName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      planInfo: {} as GetUpgradeCodeQualitySubscriptionPlanInfoPayload,
      updatingSubscription: false
    }
  },
  async fetch(): Promise<void> {
    const { owner, provider } = this.$route.params
    await this.fetchBillingDetails({
      login: owner,
      provider
    })

    this.planInfo = await this.getUpgradePlanInfo({
      id: this.owner.id,
      planSlug: this.newPlanName
    })
  },
  computed: {
    newPlan(): Record<string, string | number> {
      return this.context.plans[this.newPlanName]
    }
  },
  methods: {
    getDefaultAvatar,
    parseISODate,
    formatDate,
    formatUSD,
    pluralize,
    async switchPlan(close: () => void): Promise<void> {
      this.updatingSubscription = true
      try {
        await this.changeSubscriptionPlan({
          id: this.owner.id,
          planSlug: this.newPlanName
        })
        this.$emit('refetch')

        const { owner, provider } = this.$route.params
        await this.fetchBillingDetails({
          login: owner,
          provider,
          refetch: true
        })
        this.$toast.success('Successfully updated the subscription.')

        if (close) {
          close()
        } else {
          this.$emit('close')
        }
      } catch (e) {
        this.$toast.danger('Something went wrong while changing the subscription.')
      } finally {
        this.updatingSubscription = false
      }
    }
  }
})
